export default __webpack_public_path__ + "1a6bcd02696a17204df9eaaae8c7aff5.png";